
// 目录：
// 将声明的内容复制到屏幕可见区域
//判断元素是否包含title字眼，如果是则role=heading
// 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
// 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
// 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true
// tab键盘focus元素，当按下enter回车则触发元素的click事件
// 移除klaviyo form表单中的aria-live属性


 /**
   * 公告栏弹窗
   * 
   */
 function announcementAccessFun(){
  document.addEventListener('DOMContentLoaded', function() {
    const announcement = document.getElementById('accessibility-announcement');
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {       
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div');
      visibleAnnouncement.style.position = 'absolute';
      visibleAnnouncement.style.top = '0';
      visibleAnnouncement.style.left = '0';
      visibleAnnouncement.style.width = '1px';
      visibleAnnouncement.style.height = '1px';
      visibleAnnouncement.style.overflow = 'hidden';
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

 // 调用函数发布声明
 announceAccessibilityStatement();
  });
}
/**
* 新窗口打开外部链接
* 
*/
function targetlinkFun (){
// ADA: Open a new window for external website links
var links = document.querySelectorAll('a[href]:not([data-fancybox]):not(.useless-label-link)'); 
var currentHost = window.location.hostname; 

for (var i = 0; i < links.length; i++) {
    var link = links[i];
    const parent = link.parentElement;
    if (!parent || parent.getAttribute('aria-hidden') !== 'true') {
      if( !link.hasAttribute('tabindex')){
        link.setAttribute('tabindex', '0');
      } 
    }
    // if (!link.hasAttribute('aria-label')) {
  
    //   // 添加 aria-label 属性，并设置值为元素的文本内容
    //   var text = link.textContent.trim();
    //   if(text && !link.hasAttribute('aria-label'))link.setAttribute('aria-label', text);
    // }
    
    if (!link.target && isExternalLink(link.href, currentHost)) { 
        link.target = '_blank'; 
        link.setAttribute('role', 'button');
        link.setAttribute('aria-label', link.innerText + ', open in a new tab');
        link.rel = 'noopener noreferrer nofollow'; 
    }
}

function isExternalLink(href, currentHost) {
  if (href.startsWith('mailto:')) {
    return false;
}else{
  var url = new URL(href);
  return url.hostname !== currentHost; 
}
}
}
/**
* 判断元素是否标题，如果是则添加heading角色
* 
*/
function titleroleFun (){
// 判断元素是否标题，如果是则添加heading角色

const elementstitle = document.querySelectorAll('h2:not(.useless-label-title), h3:not(.useless-label-title), h4:not(.useless-label-title), h5:not(.useless-label-title), h6:not(.useless-label-title)'); 
// 遍历这些元素并执行操作
elementstitle.forEach(function(element) {
  if (!element.hasAttribute('role')) {
    element.setAttribute('role', 'heading');
  }
    
    if (!element.hasAttribute('aria-label')) {
      
      // 添加 aria-label 属性，并设置值为元素的文本内容
      var text = element.textContent;
      element.setAttribute('aria-label', text);
    } 
});

  }

/**
* 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
* 
*/
function imgALTFun(){

  const images = document.getElementsByTagName('img');

  Array.from(images).forEach((image) => {
    if (!image.hasAttribute('alt')) {
      image.setAttribute('alt', ' ');
    }
    if (image.hasAttribute('empty-alt') && image.getAttribute('alt') === ' ') {
      image.setAttribute('alt', ''); // 针对装饰性图片，只追加alt属性，但不设置任何值（包括空格）
    }
  });
}
/**
* 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
* 
*/ 
function svgariaFun(){
const svgs = document.getElementsByTagName('svg');

Array.from(svgs).forEach((svg) => {
if (!svg.hasAttribute('aria-labelledby')) {
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
}
});
}
/**
* 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true
* 
*/  
function inputlabelFun(){
const inputs = document.querySelectorAll("input[type='password'], input[type='email'], input[type='text']");

Array.from(inputs).forEach((input) => {
if (!input.hasAttribute('aria-label')) {
  const placeholder = input.getAttribute('placeholder');
  const value = input.value;
  const labelValue = placeholder || value;
  if(labelValue)input.setAttribute('aria-label', labelValue);
}
if (input.hasAttribute('required')) {
  input.setAttribute('aria-required', 'true');
}
});
}
/**
* 监听键盘事件，当按下tab后锁定元素 ，再按enter，则触发click事件
* 
*/   
function tabtoClickFun(){
// 监听键盘事件
let currentFocusedElement = null; // 用于存储当前聚焦的元素
      document.addEventListener('keyup', (event) => {
          if (event.key === 'Tab') {
              currentFocusedElement = document.activeElement;
               console.log('当前聚焦的元素:', currentFocusedElement);
          }

          // 当按下 Enter 键
          if (event.key === 'Enter' && currentFocusedElement) {
              // 触发当前聚焦元素的 click 事件
              currentFocusedElement.click();
               console.log('触发了点击事件:', currentFocusedElement);
          }
      });
      
}

/**
* 产品页内related video 页签内的图片动态加alt值，a标签动态加aria-label值
* 
*/  
function tosotrwdvidoeFun(){

if (document.body.classList.contains('template-product')) {


// 获取所有具有样式名为 "rwd-video" 的元素
var rwdVideos = document.getElementsByClassName('rwd-video');

// 遍历每个 rwd-video 元素
for (var i = 0; i < rwdVideos.length; i++) {
var rwdVideo = rwdVideos[i];

// 获取 rwd-video 元素内的 h2 元素、a 元素和图片元素
var h2Element = rwdVideo.querySelector('h2');
var aElement = rwdVideo.querySelector('a');
var imgElement = rwdVideo.querySelector('img');

// 设置 a 元素的 aria-label 属性为 h2 元素的文本内容
aElement.setAttribute('aria-label', h2Element.textContent)
// 设置图片元素的 alt 属性为 h2 元素的文本内容
imgElement.alt = h2Element.textContent;
}
}
}

function nomoreH1roleFun(){
const headings_h1 = document.querySelectorAll('h1');

  // 遍历每个 h1 元素
  headings_h1.forEach(heading => {
      if (!heading.classList.contains('header-logo')) {
          // 创建新的 h2 元素
          const newHeading = document.createElement('h2');
          // 将 h1 的内容复制到新的 h2 元素
          newHeading.innerHTML = heading.innerHTML;
          // 替换 h1 为新的 h2
          heading.parentNode.replaceChild(newHeading, heading);
      }
  });
}

function escCloseModal(){
// 关闭加购后插件弹窗
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') { // 检查是否按下 Esc 键
    setTimeout(() => {
      let cart_drawer = document.querySelector("cart-drawer");
      let revy_winow=  document.querySelector(".revy-upsell-popup-close-icon"); 
     if (cart_drawer && cart_drawer.classList.contains('active')) {
      document.querySelector(".drawer__close").click();
      } 
      if(revy_winow) {
        revy_winow.click();
        document.querySelector(".product-form__submit")?.focus();
      }
     }, 500);
     
  }
});
}

function klaviyoFormAriaLiveRemove(){
document.addEventListener("DOMContentLoaded", () => {
  let klaviyoForms = document.querySelectorAll(`.klaviyo-form form[aria-live="polite"]`);
  klaviyoForms.forEach((form) => {
    form.removeAttribute("aria-live");
  });
});
}

function sswFormRequire(){
  document.addEventListener("DOMContentLoaded", () => {
    let sswTargetIds = ["login_modal", "signup_modal"]; // 需要监听的 ID
    let sswObserver = new MutationObserver(() => {
      sswTargetIds.forEach(id => {
        let element = document.getElementById(id);
        if (element) {
          // 关闭modal后focus到wishlist按钮上
          let closeModalFocusObserver = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              if ((mutation.attributeName === "class" && !element.classList.contains("ssw-in")) || (mutation.attributeName === "aria-hidden" && element.getAttribute("aria-hidden") === "true")) {
                if(!document.querySelector("#signup_modal")?.classList.contains("ssw-in") && !document.querySelector("#login_modal")?.classList.contains("ssw-in")) {
                  let focusEl = document.querySelector(".ssw-fave-btn button") || document.querySelector("[tabindex='0']");
                  focusEl?.focus();
                }
              }
            });
          });
          closeModalFocusObserver.observe(element, { attributes: true, attributeFilter: ["class", "aria-hidden"] }); // 开始监听

          // 动态添加 role="dialog" and aria-modal="true"
          element.setAttribute("role", "dialog");
          element.setAttribute("aria-modal", "true");

          // 动态向整体的ssw-close增加相关信息, 并追加first-focusable-element
          let modalClose = element.querySelector(".ssw-close");
          modalClose.setAttribute("aria-label", "Close");
          modalClose.classList.add("first-focusable-element");
          let modalCloseSrOnly = document.createElement("span"); // 创建ssw-close sr-only新元素
          modalCloseSrOnly.textContent = "Close"; // 设置内容
          modalCloseSrOnly.classList.add("sr-only");
          modalClose.appendChild(modalCloseSrOnly); // 追加到ssw-close内部

          // 动态增加last-focus-element
          let sswModalLastFocusElement = document.createElement("a"); // 创建last-focusable-element新元素
          sswModalLastFocusElement.textContent = "Skip"; // 设置内容
          sswModalLastFocusElement.setAttribute("rel", "nofollow");
          sswModalLastFocusElement.setAttribute("tabindex", "0");
          sswModalLastFocusElement.classList.add("last-focusable-element");
          element.querySelector(".ssw-modal-content")?.append(sswModalLastFocusElement); // 追加到modal内部

          // 确保focus焦点一直在modal里轮询
          let sswFirstFocusableElement = element.querySelector("input[type='email']") || element.querySelector(".first-focusable-element");
          let sswLastFocusableElement = element.querySelector(".last-focusable-element");
          element.addEventListener('keydown', function(e) {
            if(e.target == sswFirstFocusableElement && e.key == "Tab" && e.shiftKey) {
              e.preventDefault();
              sswLastFocusableElement.focus();
            } else if(e.target == sswLastFocusableElement && e.key == "Tab" && !e.shiftKey) {
              e.preventDefault();
              sswFirstFocusableElement.focus();
            }
          });

          // 替换ssw-h3为 h3 标签
          if(element.querySelector(".ssw-h3")) {
            let oldHeadingElement = element.querySelector(".ssw-h3");
            let newHeadingElement = document.createElement("h3");
            newHeadingElement.innerHTML = oldHeadingElement.innerHTML;
            newHeadingElement.className = oldHeadingElement.className;
            if(oldHeadingElement.id) {newHeadingElement.id = oldHeadingElement.id;}
            newHeadingElement.setAttribute("role", "heading");
            newHeadingElement.setAttribute("aria-label", oldHeadingElement.innerHTML);
            newHeadingElement.setAttribute("title", oldHeadingElement.innerHTML);
            oldHeadingElement.parentNode.replaceChild(newHeadingElement, oldHeadingElement);

            // 动态向modal添加aria-label
            element.setAttribute("aria-label", oldHeadingElement.innerHTML);
          }

          // 处理social icons细节
          if(element.querySelector(".ssw-socialconnect")) {
            let oldSocialElement = element.querySelector(".ssw-socialconnect");
            let newSocialElement = document.createElement("ul");
            // 遍历所有子元素<div>，转换为 <li>
            Array.from(oldSocialElement.children).forEach((child) => {
              let templi = document.createElement("li");
              templi.innerHTML = child.innerHTML;
              templi.className = child.className;
              if(child.id) {templi.id = child.id;}
              newSocialElement.appendChild(templi);
            });
            newSocialElement.className = oldSocialElement.className;
            if(oldSocialElement.id) {newSocialElement.id = oldSocialElement.id;}
            oldSocialElement.parentNode.replaceChild(newSocialElement, oldSocialElement);
            
            // 移除modal中social icons的 tabindex 和 aria-label 属性
            element.querySelectorAll(".ssw-social-btn a")?.forEach(el => {
              el.getAttribute("tabindex") && el.removeAttribute("tabindex");
              el.getAttribute("aria-label") && el.removeAttribute("aria-label");

              // 对icon中的图像增加aria-hidden
              if(el.querySelector("svg") || el.querySelector("i")) {
                el.querySelector("svg") && el.querySelector("svg").setAttribute("aria-hidden", "true");
                el.querySelector("i") && el.querySelector("i").setAttribute("aria-hidden", "true");
              }
            });
          }

          // 对form增加必填项指示文案
          if(element.querySelector("form")) {
            let requiredIndicated = document.createElement("small");
            requiredIndicated.classList.add("indicate-text");
            requiredIndicated.innerText = "* indicates a required field."
            element.querySelector("form").prepend(requiredIndicated);
          }

          // 给表单字段添加 required 属性
          element.querySelectorAll("input[type='email'], input[type='password'], input.required")?.forEach((el, index) => {
            // 动态增加 required 属性
            el.setAttribute("required", "required");
            // 动态修改 autocomplete 具体属性值
            el.getAttribute("type") === "email" && el.setAttribute("autocomplete", "email");
            if(id === "login_modal") {
              el.getAttribute("type") === "password" && el.setAttribute("autocomplete", "current-password");

              // 监听 #login_modal 内部的 .ssw-alert.ssw-alert-warning, 追加 role 和 aria-label
              let sswAlertObserver = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                  mutation.addedNodes.forEach(alertNode => {
                    if (alertNode.nodeType === 1 && alertNode.classList.contains("ssw-alert") && alertNode.classList.contains("ssw-alert-warning")) { 
                      alertNode.setAttribute("role", "region");
                      alertNode.setAttribute("aria-label", "Warning Message");

                      // 移动 ssw-close 到 alertNode 内部的最后
                      let closeElement = alertNode.querySelector(".ssw-close");
                      if(closeElement) {alertNode.appendChild(closeElement);}
                    }
                  });
                });
              });
              // 监听 login_modal 内部的变动
              sswAlertObserver.observe(document.getElementById(id), { childList: true, subtree: true });
            } else if (id === signup_modal) {
              el.getAttribute("type") === "password" && el.setAttribute("autocomplete", "new-password");
              el.getAttribute("name").contains("first_name") && el.setAttribute("autocomplete", "given-name");
              el.getAttribute("name").contains("last_name") && el.setAttribute("autocomplete", "family-name");
            }
            // 动态增加错误提示aria-describedby & 动态增加label
            let newElement = document.createElement("span");
            newElement.classList.add("sr-only");
            newElement.textContent = el.getAttribute("aria-label") ? `${el.getAttribute("aria-label")}. This field is required.` : "This field is required.";
            let newLabel = document.createElement("label");
            newLabel.innerHTML = el.getAttribute("placeholder") ? `${el.getAttribute("placeholder")} <small>*</small>` : `${el.getAttribute("aria-label")} <small>*</small>`;
            if(el.getAttribute("id")) {
              el.setAttribute("aria-describedby", `${el.getAttribute("id")}_error`);
              newElement.setAttribute("id", `${el.getAttribute("id")}_error`);
              el.insertAdjacentElement("afterend", newElement);

              newLabel.setAttribute("for", el.getAttribute("id"));
              el.insertAdjacentElement("beforebegin", newLabel);
            } else {
              el.setAttribute("id", `ssw_customerid_${index + 1}`);
              el.setAttribute("aria-describedby", `ssw_customerid_${index + 1}_error`);
              newElement.setAttribute("id", `ssw_customerid_${index + 1}_error`);
              el.insertAdjacentElement("afterend", newElement);
            }
          });
          // 从待监听列表中移除已处理的 ID
          sswTargetIds.splice(sswTargetIds.indexOf(id), 1);
        }
      });
      // 当所有目标元素都加载完后，停止监听
      if (sswTargetIds.length === 0) {
        sswObserver.disconnect();
      }
    });
    // 监听整个 `document.body`，监测子元素变化
    sswObserver.observe(document.body, { childList: true, subtree: true });
  });
}

announcementAccessFun();
targetlinkFun();
titleroleFun();
imgALTFun();
svgariaFun();
inputlabelFun();
// tabtoClickFun();
nomoreH1roleFun();
escCloseModal();
// tosotrwdvidoeFun();
klaviyoFormAriaLiveRemove();
sswFormRequire();